export default __webpack_public_path__ + "static/media/kitchen3-afterE-480w.a28e98fd.webp";